@if (file) {
  <div class="file-item" [class.error]="file.error">
    <i
      class="fa-solid file-type-icon"
      [ngClass]="file.icon"
      aria-hidden="true"
    ></i>
    <div class="uploaded-file-details">
      <span class="file-name">{{ file.file.name }}</span>
      <span class="file-size">{{ getSize(file.file.size) }}</span>
    </div>
    <div class="uploading-error" [class.none]="!file.error">
      <i class="fa-solid fa-circle-exclamation"></i> {{ file.error || '' }}
    </div>
    @if (file.error) {
      <button
        class="btn btn-link remove action-icon"
        type="button"
        (click)="removeFile()"
        aria-label="Remove file"
        >
        <i class="fa-solid fa-xmark"></i>
      </button>
    }
    @if (!file.error) {
      <div class="uploading-spinner">
        <span class="uploading-text">File processing...</span>
        <app-spinner [styleRules]="{ transform: 'scale(0.7)' }"></app-spinner>
      </div>
    }
  </div>
}
